export default {
  search_placeholder: "Destinations Search",
  places_around: "Near Current Location",
  reward_type: "Reward Type",
  pr_method: "PR Methods",
  sns_specify: "Preferred Social Media Platforms",
  age_specify: "Preferred Influencers Age Range",
};
